module.exports = __webpack_public_path__ + "0e2f519ba94863f33da3b65e3f963070.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/music.png
// module id = 972
// module chunks = 0